import { Check, X } from "lucide-react";

const ProsCons = ({ pros, cons }) => (
  <div className="grid gap-6 md:grid-cols-2" data-testid="pros-cons">
    <div className="rounded-2xl border border-volt/25 bg-cardink p-7">
      <p className="overline-label mb-5 !text-volt">What We Love</p>
      <ul className="space-y-3.5">
        {pros.map((pro, i) => (
          <li key={i} className="flex items-start gap-3 text-sm leading-relaxed text-white/80" data-testid={`pro-${i}`}>
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-volt" strokeWidth={3} />
            {pro}
          </li>
        ))}
      </ul>
    </div>
    <div className="rounded-2xl border border-white/[0.08] bg-cardink p-7">
      <p className="overline-label mb-5 !text-red-400/80">Worth Knowing</p>
      <ul className="space-y-3.5">
        {cons.map((con, i) => (
          <li key={i} className="flex items-start gap-3 text-sm leading-relaxed text-white/80" data-testid={`con-${i}`}>
            <X className="mt-0.5 h-4 w-4 shrink-0 text-red-400/80" strokeWidth={3} />
            {con}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default ProsCons;
